{
    "Budō Lineage Tree": "Árvore de artes marciais",
    "Teachers": "Professores",
    "Students": "Estudantes",
    "Rank": "Graduação",
    "Sources": "Fontes",
    "Tree": "Árvore",
    "Persons": "Pessoas",
    "Styles": "Estilos",
    "All Styles": "Todos os Estilos",
    "Timeline": "Linha do Tempo"
}
